import React from 'react';
import { Collapse } from 'reactstrap';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import styles from './index.module.scss';

import { If } from 'utils';
import { TableRow } from 'components/Tables';

export default function ExceptionEntityTableRows({
  rows = [],
  active = {},
  onClick = () => {}
}) {
  if (_isEmpty(rows)) return null;

  return rows.map((row, index) => {
    const rowData = _get(row, 'rowData', {});
    const collapsedRowsData = _get(row, 'collapsedRowsData', []);

    const id = _get(rowData, 'id', index);
    const values = _get(rowData, 'values', []);
    const disabled = _get(rowData, 'disabled', false);
    const isExpanded = _get(active, id, false);

    const collapsedRows = collapsedRowsData.map((rowData, index) => {
      const id = _get(rowData, 'id', index);
      const values = _get(rowData, 'values', []);
      const disabled = _get(rowData, 'disabled', false);
      return <TableRow key={id} values={values} disabled={disabled} />;
    });

    const canExpand = !_isEmpty(collapsedRows);

    return (
      <div key={id} data-open={isExpanded}>
        <TableRow
          values={values}
          onClick={() => !disabled && onClick(id)}
          disabled={disabled}
          customTableRowClass={canExpand ? styles.clickable : null}
        />
        <If test={canExpand}>
          <Collapse isOpen={isExpanded} className={styles.collapse}>
            {collapsedRows}
          </Collapse>
        </If>
      </div>
    );
  });
}
